import React from "react";
import LBox from "@components/LBox";
import LText from "@components/LText";
import { fonts } from "@theme";
import Animated, { withTiming, Easing } from "react-native-reanimated";

const entering = () => {
  "worklet";
  const animations = {
    opacity: withTiming(1, { duration: 250 }),
    transform: [
      {
        translateY: withTiming(0, {
          duration: 300,
          easing: Easing.out(Easing.cubic),
        }),
      },
      {
        scale: withTiming(1, {
          duration: 300,
          easing: Easing.out(Easing.cubic),
        }),
      },
    ],
  };
  const initialValues = {
    opacity: 0,
    transform: [{ translateY: 16 }, { scale: 0.85 }],
  };
  return { animations, initialValues };
};

const exiting = () => {
  "worklet";
  const animations = {
    opacity: withTiming(0, { duration: 180 }),
    transform: [
      {
        translateY: withTiming(-14, {
          duration: 220,
          easing: Easing.in(Easing.cubic),
        }),
      },
      {
        scale: withTiming(0.85, {
          duration: 220,
          easing: Easing.in(Easing.cubic),
        }),
      },
    ],
  };
  const initialValues = {
    opacity: 1,
    transform: [{ translateY: 0 }, { scale: 1 }],
  };
  return { animations, initialValues };
};

const PeopleStatPill = ({ text }: { text: string }) => (
  <Animated.View key={text} entering={entering} exiting={exiting}>
    <LBox
      backgroundColor="closeButtonBg"
      borderRadius="max"
      paddingHorizontal="s4"
      paddingVertical="s2"
    >
      <LText
        fontSize={14}
        fontFamily={fonts.medium}
        color="whiteTranslucent60"
      >
        {text}
      </LText>
    </LBox>
  </Animated.View>
);

export default PeopleStatPill;
